import api from '@/services/api/baseApi';
import type { ApiResponse } from '@/models/common/ApiResponse';
import { type Setting } from '@/models/Setting';
import SettingsUrls from '../urls/setting.url';

export const useSettingApi = () => {
  const fetchSettingsByCodes = async (codes: string): Promise<Setting[]> => {
    const response: ApiResponse<Setting[]> = await api.get(`${SettingsUrls.GetByCodes}${codes}`);
    return response.data.body;
  };

  return { fetchSettingsByCodes };
};
